import { PrismicRichText } from '@prismicio/react';
import { Col, Container, Row } from "react-bootstrap";

import './hero.scss';

const HeroSection = ({ slice }) => {

  let imgPrincipalUrl;

  if (slice.primary.hero_image && slice.primary.hero_image.url) {
    imgPrincipalUrl = slice.primary.hero_image.url;
  }

  return (
    <section className={`bienvenidosPrincipal ${slice.primary.type_background}`}>
      <div className="divPrincipal">
        <section className="textoPrincipal">
          <Container>
            <Row>
              <Col xs="11" sm="11" md="11" className="m-auto">
                <article className="contenidoTexto">
                  <PrismicRichText field={slice.primary.hero_title} />
                  <PrismicRichText field={slice.primary.hero_description} />
                </article>
              </Col>
            </Row>
          </Container>
        </section>
        {slice.items.length > 0 && (
          <section className="flechaBajar">
            <Container>
              <Row>
                {slice.items.map(({ type, cta_link, cta_label, icon }) => (
                  <a key={cta_link} href={cta_link} className={`flcBajar btn ${type}`}>{cta_label}</a>
                ))}
              </Row>
            </Container>
          </section>
        )}
      </div>
      <div className="imgPrincipal2" style={{ backgroundImage: `url(${imgPrincipalUrl})` }}></div>
    </section>
  );
}

export default HeroSection;
